var render = function () {
  var _vm$detail, _vm$detail$statusDeta, _vm$detail2, _vm$detail2$statusDet, _vm$detail3, _vm$detail3$statusDet, _vm$detail3$statusDet2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "Refund Detail",
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "width": "1200px",
      "top": "3vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    ref: "dataForm",
    attrs: {
      "autocomplete": "off",
      "label-position": "top"
    }
  }, [_c('el-row', {
    staticClass: "pb10",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Refund Items"
    }
  }, [_c('el-table', {
    staticClass: "wdb100",
    attrs: {
      "data": ((_vm$detail = _vm.detail) === null || _vm$detail === void 0 ? void 0 : (_vm$detail$statusDeta = _vm$detail.statusDetail) === null || _vm$detail$statusDeta === void 0 ? void 0 : _vm$detail$statusDeta.refundInfoList) || [],
      "size": "medium",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Description",
      "prop": "orderDescription",
      "align": "center"
    }
  }), _c('el-table-column', {
    attrs: {
      "label": "Gov Fee",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', {
          staticClass: "orange"
        }, [_vm._v(_vm._s(_vm.currencyAndAmountFormat(_vm.billingCurrency(scope.row.bankAccountIds), scope.row.deductionAcraFee)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": "Handling Fee",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', {
          staticClass: "orange"
        }, [_vm._v(_vm._s(_vm.currencyAndAmountFormat(_vm.billingCurrency(scope.row.bankAccountIds), scope.row.deductionHandlingFee)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": "Invoice Template",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.invoiceTemplate(scope.row.invoiceTemplateId)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": "Bank Accounts",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.bankAccountList(scope.row.bankAccountIds)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": "Apply Reason",
      "prop": "applyReason",
      "align": "center"
    }
  })], 1)], 1)], 1), (_vm$detail2 = _vm.detail) !== null && _vm$detail2 !== void 0 && (_vm$detail2$statusDet = _vm$detail2.statusDetail) !== null && _vm$detail2$statusDet !== void 0 && _vm$detail2$statusDet.remark ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Remark"
    }
  }, [_c('p', {
    staticClass: "m0 lh22"
  }, [_vm._v(_vm._s(_vm.detail.statusDetail.remark))])])], 1) : _vm._e(), ((_vm$detail3 = _vm.detail) === null || _vm$detail3 === void 0 ? void 0 : (_vm$detail3$statusDet = _vm$detail3.statusDetail) === null || _vm$detail3$statusDet === void 0 ? void 0 : (_vm$detail3$statusDet2 = _vm$detail3$statusDet.attachmentUrls) === null || _vm$detail3$statusDet2 === void 0 ? void 0 : _vm$detail3$statusDet2.length) > 0 ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Attachments"
    }
  }, _vm._l(_vm.detail.statusDetail.attachmentUrls, function (item, idx) {
    return _c('p', {
      key: "attachmentUrls".concat(idx),
      staticClass: "fs13 m0 lh26"
    }, [_c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.name))])]);
  }), 0)], 1) : _vm._e()], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }